import { render, staticRenderFns } from "./AnalyticsTabNavigation.vue?vue&type=template&id=72d67187&"
import script from "./AnalyticsTabNavigation.vue?vue&type=script&lang=js&"
export * from "./AnalyticsTabNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports